import { Routes } from '@angular/router';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { AccessRestrictedComponent } from './pages/access-restricted/access-restricted.component';
import { CallbackComponent } from './pages/callback/callback.component';
import { LogoutComponent } from './pages/logout/logout.component';

export const authRoutes: Routes = [
  {
    path: 'implicit/callback',
    component: CallbackComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: 'access-restricted',
    component: AccessRestrictedComponent
  },
];
